import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

import { createMaterial as createMaterialApi } from "../../../../services/dashboard/apiLecture";

function useUploadMaterial() {
    const queryClient = useQueryClient();

    const {
        mutate: uploadMaterial,
        isPending: isUploading,
        error,
    } = useMutation({
        mutationFn: createMaterialApi,

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["lectureMaterials"],
            });

            toast.success("تم إرفاق الملف للمحاضره بنجاح");
        },

        onError: (error) => {
            toast.error(error.response.data.message);
        },
    });

    return { uploadMaterial, isUploading, error };
}

export default useUploadMaterial;
